<template>
  <b-container class="legislacao-page">
    <div class="legislacao-shell" v-loading="loading">
      <aside class="legislacao-sidenav" aria-label="Categorias">
        <button
          type="button"
          class="legislacao-navbtn legislacao-navbtn--home"
          :class="{ 'legislacao-navbtn--active': !activeItem }"
          @click="clearCategory"
        >
          <span class="legislacao-navbtn__icon-wrap">
            <i class="fas fa-home" aria-hidden="true"></i>
          </span>
          <span class="legislacao-navbtn__text">Início e normas recentes</span>
        </button>

        <nav class="legislacao-sidenav__scroll">
          <button
            v-for="legisla in legislacoes"
            :key="legisla.id"
            type="button"
            class="legislacao-navbtn"
            :class="{
              'legislacao-navbtn--active': isActive(String(legisla.id)),
            }"
            @click="openCategory(legisla.id)"
          >
            <span class="legislacao-navbtn__icon-wrap">
              <i
                :class="iconClassForCategory(legisla.id)"
                aria-hidden="true"
              ></i>
            </span>
            <span class="legislacao-navbtn__text">{{ legisla.titulo }}</span>
          </button>
        </nav>
      </aside>

      <div class="legislacao-panel">
        <header class="legislacao-panel__head">
          <h1 class="legislacao-panel__title">Legislação</h1>
          <p class="legislacao-panel__subtitle">
            Consulte normas municipais por categoria ou use a busca.
          </p>
        </header>

        <form class="legislacao-main-search" @submit.prevent="runSearchNow">
          <b-input-group class="legislacao-main-search__group">
            <template #prepend>
              <b-input-group-text class="legislacao-main-search__prepend">
                <i class="fas fa-search" aria-hidden="true"></i>
              </b-input-group-text>
            </template>
            <b-form-input
              v-model="panelSearch"
              type="search"
              autocomplete="off"
              :placeholder="searchPlaceholder"
              @input="onPanelSearchInput"
            />
            <b-input-group-append>
              <b-button type="submit" class="legislacao-main-search__btn">
                Buscar
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </form>

        <div class="legislacao-accordions">
          <button
            type="button"
            class="legislacao-acc-item"
            :aria-expanded="acc.filtro ? 'true' : 'false'"
            @click="acc.filtro = !acc.filtro"
          >
            <span class="legislacao-acc-item__icon">{{
              acc.filtro ? "−" : "+"
            }}</span>
            Filtrar legislação
          </button>
          <b-collapse v-model="acc.filtro" class="legislacao-acc-body">
            <label class="legislacao-acc-label" for="legislacao-filtro-cat"
              >Categoria</label
            >
            <b-form-select
              id="legislacao-filtro-cat"
              v-model="filtroCategoriaId"
              :options="categoriaSelectOptions"
              class="mb-2"
            />
            <b-button
              variant="primary"
              size="sm"
              class="legislacao-acc-apply"
              @click="aplicarFiltroCategoria"
            >
              Aplicar
            </b-button>
          </b-collapse>

          <button
            type="button"
            class="legislacao-acc-item"
            :aria-expanded="acc.avancada ? 'true' : 'false'"
            @click="acc.avancada = !acc.avancada"
          >
            <span class="legislacao-acc-item__icon">{{
              acc.avancada ? "−" : "+"
            }}</span>
            Pesquisa avançada
          </button>
          <b-collapse v-model="acc.avancada" class="legislacao-acc-body">
            <p class="legislacao-acc-muted mb-0">
              Refine por categoria no menu à esquerda ou use palavras-chave na
              busca principal.
            </p>
          </b-collapse>

          <button
            type="button"
            class="legislacao-acc-item"
            :aria-expanded="acc.assunto ? 'true' : 'false'"
            @click="acc.assunto = !acc.assunto"
          >
            <span class="legislacao-acc-item__icon legislacao-acc-item__chev">{{
              acc.assunto ? "∨" : "›"
            }}</span>
            Legislação por assunto
          </button>
          <b-collapse v-model="acc.assunto" class="legislacao-acc-body">
            <ul class="legislacao-assunto-list">
              <li v-for="c in legislacoes" :key="'a-' + c.id">
                <button type="button" @click="openCategory(c.id)">
                  {{ c.titulo }}
                </button>
              </li>
            </ul>
          </b-collapse>
        </div>

        <section class="legislacao-results" v-loading="loadingActive">
          <template v-if="!activeItem && globalQueryTrim.length >= 2">
            <h2 class="legislacao-results__heading">Resultados da pesquisa</h2>
            <div class="legislacao-results__rule"></div>
            <div v-loading="loadingPesquisaGlobal">
              <ul
                v-if="pesquisaGlobal.data && pesquisaGlobal.data.length"
                class="legislacao-norma-list"
              >
                <li
                  v-for="row in pesquisaGlobal.data"
                  :key="'g-' + row.id"
                  class="legislacao-norma-list__item"
                >
                  <div class="legislacao-norma-list__head">
                    <span class="legislacao-norma-list__tipo">{{
                      row.categoria_titulo
                    }}</span>
                    <a
                      v-if="row.url"
                      class="legislacao-norma-list__title"
                      :href="row.url"
                      target="_blank"
                      rel="noopener"
                      >{{ row.titulo }}</a
                    >
                    <span v-else class="legislacao-norma-list__title-muted">{{
                      row.titulo
                    }}</span>
                  </div>
                  <p class="legislacao-norma-list__excerpt">
                    Documento disponível na categoria
                    <button
                      type="button"
                      class="legislacao-norma-list__link"
                      @click="openCategory(row.legislacao_categoria_id)"
                    >
                      {{ row.categoria_titulo }}
                    </button>
                    .
                  </p>
                </li>
              </ul>
              <p v-else-if="!loadingPesquisaGlobal" class="legislacao-empty">
                Nenhum documento encontrado.
              </p>
              <div
                v-if="pesquisaGlobal.total > pesquisaGlobal.per_page"
                class="legislacao-pg"
              >
                <b-pagination
                  v-model="pesquisaGlobalPage"
                  align="center"
                  pills
                  :total-rows="pesquisaGlobal.total"
                  :per-page="pesquisaGlobal.per_page"
                  @change="onPesquisaGlobalPage"
                />
              </div>
            </div>
          </template>

          <template v-else-if="activeItem">
            <h2 class="legislacao-results__heading">
              {{ activeCategoryTitle }}
            </h2>
            <div class="legislacao-results__rule"></div>
            <ul
              v-if="legislaActive.data && legislaActive.data.length"
              class="legislacao-norma-list"
            >
              <li
                v-for="data in legislaActive.data"
                :key="data.id"
                class="legislacao-norma-list__item"
              >
                <div class="legislacao-norma-list__head">
                  <a
                    v-if="data.url"
                    class="legislacao-norma-list__title"
                    :href="data.url"
                    target="_blank"
                    rel="noopener"
                  >
                    <i
                      class="fas fa-file-pdf legislacao-norma-list__pdf"
                      aria-hidden="true"
                    ></i>
                    {{ data.titulo }}
                  </a>
                  <span v-else class="legislacao-norma-list__title-muted">{{
                    data.titulo
                  }}</span>
                </div>
              </li>
            </ul>
            <p v-else-if="!loadingActive" class="legislacao-empty">
              Não foram encontrados resultados para essa busca.
            </p>
            <div
              v-if="legislaActive.data && legislaActive.data.length"
              class="legislacao-pg"
            >
              <b-pagination
                v-model="legislaActive.current_page"
                align="center"
                pills
                :total-rows="legislaActive.total"
                :per-page="legislaActive.per_page"
                @change="handleChangePage"
              />
            </div>
          </template>

          <template v-else>
            <h2 class="legislacao-results__heading">Normas recentes</h2>
            <div class="legislacao-results__rule"></div>
            <ul v-if="normasRecentes.length" class="legislacao-norma-list">
              <li
                v-for="row in normasRecentes"
                :key="'r-' + row.id"
                class="legislacao-norma-list__item"
              >
                <div class="legislacao-norma-list__head">
                  <span class="legislacao-norma-list__tipo">{{
                    row.categoria_titulo
                  }}</span>
                  <a
                    v-if="row.url"
                    class="legislacao-norma-list__title"
                    :href="row.url"
                    target="_blank"
                    rel="noopener"
                    >{{ row.titulo }}</a
                  >
                  <span v-else class="legislacao-norma-list__title-muted">{{
                    row.titulo
                  }}</span>
                </div>
                <p class="legislacao-norma-list__excerpt">
                  Categoria:
                  <button
                    type="button"
                    class="legislacao-norma-list__link"
                    @click="openCategory(row.legislacao_categoria_id)"
                  >
                    {{ row.categoria_titulo }}
                  </button>
                </p>
              </li>
            </ul>
            <p v-else-if="!loadingRecentes" class="legislacao-empty">
              Nenhuma norma cadastrada no momento.
            </p>
          </template>
        </section>
      </div>
    </div>
  </b-container>
</template>

<script>
let globalSearchDebounceId = null;
let categoryFilterDebounceId = null;

const CATEGORY_ICONS = {
  1: ["fas", "fa-landmark"],
  2: ["fas", "fa-file-contract"],
  3: ["fas", "fa-gavel"],
  4: ["fas", "fa-file-signature"],
  5: ["fas", "fa-scroll"],
  6: ["fas", "fa-file-invoice-dollar"],
  7: ["fas", "fa-shield-alt"],
  8: ["fas", "fa-sitemap"],
  9: ["fas", "fa-users-cog"],
  10: ["fas", "fa-map-marked-alt"],
  11: ["fas", "fa-broom"],
  12: ["fas", "fa-graduation-cap"],
  13: ["fas", "fa-hard-hat"],
  14: ["fas", "fa-id-badge"],
  15: ["fas", "fa-notes-medical"],
};

export default {
  name: "legislacao",
  data() {
    return {
      loading: false,
      loadingActive: false,
      loadingPesquisaGlobal: false,
      loadingRecentes: false,
      legislacoes: [],
      normasRecentes: [],
      legislaActive: {},
      activeItem: "",
      globalQuery: "",
      categoryFilterQuery: "",
      panelSearch: "",
      pesquisaGlobal: { data: [], total: 0, per_page: 15, current_page: 1 },
      pesquisaGlobalPage: 1,
      filtroCategoriaId: "",
      acc: {
        filtro: false,
        avancada: false,
        assunto: false,
      },
    };
  },
  computed: {
    globalQueryTrim() {
      return (this.globalQuery || "").trim();
    },
    searchPlaceholder() {
      return this.activeItem
        ? "Filtrar documentos nesta categoria…"
        : "Pesquisa por número do ato ou palavra-chave (Tab para navegar)";
    },
    categoriaSelectOptions() {
      return [
        { value: "", text: "Selecione…" },
        ...this.legislacoes.map((c) => ({
          value: String(c.id),
          text: c.titulo,
        })),
      ];
    },
    activeCategoryTitle() {
      const found = this.legislacoes.find(
        (c) => String(c.id) === String(this.activeItem)
      );
      return found ? found.titulo : "Legislação";
    },
  },
  watch: {
    "$route.query.categoria"(id) {
      if (id) {
        if (String(this.activeItem) !== String(id)) {
          this.openCategory(id, { skipRouter: true });
        }
      } else if (this.activeItem) {
        this.clearCategory({ skipRouter: true });
      }
    },
  },
  methods: {
    normalizeSearch(s) {
      return (s || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    iconClassForCategory(id) {
      const n = Number(id);
      return CATEGORY_ICONS[n] || ["fas", "fa-book"];
    },
    syncPanelFromMode() {
      this.panelSearch = this.activeItem
        ? this.categoryFilterQuery
        : this.globalQuery;
    },
    async getLegislacao() {
      this.loading = true;
      this.legislacoes = [];
      const res = await this.$axios.get(`legislacao`).catch((e) => {
        console.error("Legislacao", e);
      });
      if (res && res.status === 200) {
        this.legislacoes = res.data;
        const qCat = this.$route.query.categoria;
        if (qCat) {
          this.openCategory(qCat, { skipRouter: true });
        } else {
          this.syncPanelFromMode();
        }
      }
      this.loading = false;
      await this.loadRecentes();
    },
    async loadRecentes() {
      this.loadingRecentes = true;
      const res = await this.$axios
        .get(`legislacao/recentes?limit=12`)
        .catch((e) => {
          console.error("legislacao recentes", e);
        });
      if (res && res.status === 200) {
        this.normasRecentes = res.data;
      } else {
        this.normasRecentes = [];
      }
      this.loadingRecentes = false;
    },
    async getLegislacaoActive(id, pg = 1) {
      this.loadingActive = true;
      window.scrollTo({ top: 0, behavior: "smooth" });
      const q = (this.categoryFilterQuery || "").trim();
      const qs = new URLSearchParams();
      qs.set("page", String(pg));
      if (q) qs.set("q", q);
      const res = await this.$axios
        .get(`legislacao/${id}?${qs.toString()}`)
        .catch((e) => {
          console.error("Legislacao", e);
        });
      if (res && res.status === 200) {
        this.legislaActive = res.data;
      }
      this.loadingActive = false;
    },
    handleChangePage(pg) {
      this.getLegislacaoActive(this.activeItem, pg);
    },
    isActive(menuItem) {
      return this.activeItem.toString() === menuItem.toString();
    },
    onPanelSearchInput() {
      if (this.activeItem) {
        this.categoryFilterQuery = this.panelSearch;
        clearTimeout(categoryFilterDebounceId);
        categoryFilterDebounceId = setTimeout(() => {
          this.getLegislacaoActive(this.activeItem, 1);
        }, 380);
      } else {
        this.globalQuery = this.panelSearch;
        this.pesquisaGlobalPage = 1;
        clearTimeout(globalSearchDebounceId);
        globalSearchDebounceId = setTimeout(() => {
          this.runGlobalPesquisa(1);
        }, 380);
      }
    },
    runSearchNow() {
      if (this.activeItem) {
        this.getLegislacaoActive(this.activeItem, 1);
      } else {
        this.runGlobalPesquisa(1);
      }
    },
    onPesquisaGlobalPage(page) {
      this.runGlobalPesquisa(page);
    },
    async runGlobalPesquisa(page = 1) {
      const q = this.globalQueryTrim;
      if (q.length < 2) {
        this.pesquisaGlobal = {
          data: [],
          total: 0,
          per_page: 15,
          current_page: 1,
        };
        this.loadingPesquisaGlobal = false;
        return;
      }
      this.loadingPesquisaGlobal = true;
      const qs = new URLSearchParams();
      qs.set("q", q);
      qs.set("page", String(page));
      const res = await this.$axios
        .get(`legislacao/pesquisa?${qs.toString()}`)
        .catch((e) => {
          console.error("legislacao pesquisa", e);
        });
      if (res && res.status === 200) {
        this.pesquisaGlobal = res.data;
        this.pesquisaGlobalPage = res.data.current_page || page;
      }
      this.loadingPesquisaGlobal = false;
    },
    openCategory(id, opts = {}) {
      const sid = String(id);
      this.activeItem = sid;
      this.categoryFilterQuery = "";
      this.panelSearch = "";
      this.globalQuery = "";
      this.pesquisaGlobal = {
        data: [],
        total: 0,
        per_page: 15,
        current_page: 1,
      };
      this.filtroCategoriaId = sid;
      if (!opts.skipRouter) {
        this.syncRouteQuery(sid);
      }
      this.getLegislacaoActive(sid, 1);
    },
    clearCategory(opts = {}) {
      this.activeItem = "";
      this.legislaActive = {};
      this.categoryFilterQuery = "";
      this.panelSearch = "";
      this.globalQuery = "";
      this.pesquisaGlobal = {
        data: [],
        total: 0,
        per_page: 15,
        current_page: 1,
      };
      this.filtroCategoriaId = "";
      if (!opts.skipRouter && this.$route.query.categoria) {
        this.$router.replace({ path: "/legislacao" }).catch(() => {});
      }
    },
    aplicarFiltroCategoria() {
      if (!this.filtroCategoriaId) return;
      this.openCategory(this.filtroCategoriaId);
      this.acc.filtro = false;
    },
    syncRouteQuery(categoriaId) {
      const next = categoriaId ? { categoria: String(categoriaId) } : {};
      if (
        String(this.$route.query.categoria || "") !== String(categoriaId || "")
      ) {
        this.$router
          .replace({ path: "/legislacao", query: next })
          .catch(() => {});
      }
    },
  },
  created() {
    this.getLegislacao();
  },
};
</script>

<style lang="scss">
.legislacao-page {
  --leg-primary: #1f387f;
  --leg-primary-dark: #152a55;
  --leg-accent: #87a8cc;
  --leg-text-on-nav: #ffffff;
  --leg-border: #dde3eb;
  --leg-muted: #6c757d;

  &.container {
    max-width: 1200px;
  }

  font-family: Poppins, sans-serif;
  font-size: var(--font-size--default);
  color: var(--color-text, #333);
  padding-top: 24px;
  padding-bottom: 48px;
}

.legislacao-shell {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

.legislacao-sidenav {
  flex: 0 0 300px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;

  &__scroll {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-height: calc(100vh - 200px);
    overflow-y: auto;
    padding-right: 4px;
  }
}

.legislacao-navbtn {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  text-align: left;
  border: none;
  border-radius: 10px;
  padding: 12px 14px;
  cursor: pointer;
  color: var(--leg-text-on-nav);
  background: linear-gradient(
    180deg,
    var(--leg-primary) 0%,
    var(--leg-primary-dark) 100%
  );
  box-shadow: 0 2px 6px rgba(21, 42, 85, 0.25);
  transition: transform 0.15s, box-shadow 0.15s, filter 0.15s;

  &:hover {
    filter: brightness(1.06);
    box-shadow: 0 4px 12px rgba(21, 42, 85, 0.3);
  }

  &--home {
    background: linear-gradient(180deg, #2a4a9a 0%, var(--leg-primary) 100%);
  }

  &--active {
    box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--leg-accent);
    filter: brightness(1.08);
  }

  &__icon-wrap {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--leg-primary);
    font-size: 1.1rem;
    box-shadow: inset 0 0 0 1px rgba(31, 56, 127, 0.12);
  }

  &__text {
    font-size: 0.88rem;
    font-weight: 600;
    line-height: 1.35;
  }
}

.legislacao-panel {
  flex: 1;
  min-width: 0;
  background: #fff;
  border: 1px solid var(--leg-border);
  border-radius: 12px;
  padding: 22px 22px 28px;
  box-shadow: 0 4px 24px rgba(31, 56, 127, 0.06);

  &__head {
    margin-bottom: 18px;
  }

  &__title {
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--color-text-title, var(--leg-primary));
    margin: 0 0 6px;
    text-align: left;
  }

  &__subtitle {
    margin: 0;
    color: var(--leg-muted);
    font-size: 0.95rem;
    line-height: 1.45;
  }
}

.legislacao-main-search {
  margin-bottom: 14px;

  &__group .form-control {
    min-height: 48px;
    border-color: var(--leg-border);
  }

  &__prepend {
    background: #f4f6f9;
    border-color: var(--leg-border);
    color: var(--leg-primary);
  }

  &__btn {
    min-height: 48px;
    padding-left: 1.35rem;
    padding-right: 1.35rem;
    font-weight: 600;
    border: none;
    background: linear-gradient(180deg, #3a5cad 0%, var(--leg-primary) 100%);
    color: #fff !important;

    &:hover {
      filter: brightness(1.05);
    }
  }
}

.legislacao-accordions {
  margin-bottom: 22px;
}

.legislacao-acc-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  text-align: left;
  border: 1px solid var(--leg-border);
  background: #f0f3f7;
  color: #3a4a5c;
  font-weight: 600;
  font-size: 0.9rem;
  padding: 10px 14px;
  margin-bottom: 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #e8ecf2;
  }

  &__icon {
    width: 1.25rem;
    text-align: center;
    font-weight: 700;
    color: var(--leg-primary);
  }

  &__chev {
    font-size: 1rem;
    line-height: 1;
  }
}

.legislacao-acc-body {
  padding: 12px 14px 16px;
  margin: -4px 0 12px;
  border: 1px solid var(--leg-border);
  border-top: none;
  border-radius: 0 0 6px 6px;
  background: #fafbfc;
}

.legislacao-acc-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #495057;
  margin-bottom: 6px;
}

.legislacao-acc-muted {
  font-size: 0.9rem;
  color: var(--leg-muted);
  line-height: 1.45;
}

.legislacao-acc-apply {
  background: var(--leg-primary) !important;
  border-color: var(--leg-primary) !important;
}

.legislacao-assunto-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 220px;
  overflow-y: auto;

  li {
    border-bottom: 1px solid #e9ecef;
    &:last-child {
      border-bottom: none;
    }
  }

  button {
    display: block;
    width: 100%;
    text-align: left;
    border: none;
    background: none;
    padding: 8px 4px;
    color: var(--leg-primary);
    font-size: 0.9rem;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

.legislacao-results {
  &__heading {
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #495057;
    margin: 0 0 8px;
    text-align: left;
  }

  &__rule {
    height: 1px;
    background: var(--leg-border);
    margin-bottom: 16px;
  }
}

.legislacao-norma-list {
  list-style: none;
  margin: 0;
  padding: 0;

  &__item {
    padding: 14px 0;
    border-top: 1px solid #eef1f5;

    &:first-child {
      border-top: none;
      padding-top: 0;
    }
  }

  &__head {
    display: block;
  }

  &__tipo {
    display: block;
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--leg-muted);
    margin-bottom: 4px;
  }

  &__title {
    font-size: 1rem;
    font-weight: 600;
    color: var(--leg-primary);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &__title-muted {
    font-size: 1rem;
    color: #555;
  }

  &__pdf {
    color: #c0392b;
    margin-right: 8px;
  }

  &__excerpt {
    margin: 8px 0 0;
    font-size: 0.88rem;
    color: var(--leg-muted);
    line-height: 1.45;
  }

  &__link {
    padding: 0;
    border: none;
    background: none;
    color: var(--leg-primary);
    font-size: inherit;
    cursor: pointer;
    text-decoration: underline;
  }
}

.legislacao-empty {
  color: var(--leg-muted);
  margin: 0;
}

.legislacao-pg {
  margin-top: 20px;

  .page-item .page-link {
    border-radius: 50rem;
  }
}

@media only screen and (max-width: 991px) {
  .legislacao-shell {
    flex-direction: column;
  }

  .legislacao-sidenav {
    flex: none;
    width: 100%;

    &__scroll {
      max-height: 320px;
    }
  }
}
</style>
